import React, { useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import DropDown from "./DropDown";
import { HiMenu } from "react-icons/hi";
import { IconContext } from "react-icons";
import { breakpoints } from "../../utils/breakpoints";
import logo from "../../images/2025largeL.png";
import signI from "../../images/signIcon.svg";

const StyledNav = styled.div`
	width: 100%;
	font: normal normal normal 1vw/1vw Nexa-bold;
	display: flex;
	align-items: center;
	justify-content: center;
	color: white;

	.startMobile{
		display: none;
	}

	.signMobile{
		display: none;
	}

	.logo{
		display: none;
	}

	.signinbtn {
		width: 10vw;
		height: 3vw;
		cursor: pointer;
		border: none;
		outline: none;
		background: #44b2dd 0% 0% no-repeat padding-box;
		border-radius: 4px;
		font: normal normal normal 1vw/1vw Nexa-bold;
		color: #ffffff;
	}

	.signinbtn:hover {
		background: #414141 0% 0% no-repeat padding-box;
	}

	.navigation-menu ul {
		display: flex;
		align-items: center;
		padding: 0;
		margin: 0;
		column-gap: 22px;
	}

	.navigation-menu li {
		list-style-type: none;
		margin: 0 0.75rem;
		font-size: 15px;
		color: white;
	}

	.navigation-menu li a {
		text-decoration: none;
		display: block;
		width: 100%;
		text-align: center;
		color: white;

		&:hover {
			color: #44b2dd;
		}
	}

	.hamburger {
		border: 0;
		height: 45px;
		width: 45px;
		padding: 0.5rem;
		border-radius: 50%;
		background-color: #44b2dd;
		cursor: pointer;
		transition: background-color 0.2s ease-in-out;
		display: none;

		&:hover {
			background-color: #44b2dd;
		}
	}

	@media screen and ${breakpoints.device.laptop} {
		.hamburger {
			display: none;
		}

		.navigation-menu {
			ul {
				column-gap: 0px;
			}
		}
	}

	@media screen and ${breakpoints.device.tablet} {

		display: grid;
		grid-template-columns: 85% 15%;
		width: 100%;
		font-size: 3vw;

		.hamburger {
			margin: auto;
		}

		.logo {
			display: block;
		}

		.signinbtn {
			font-size: 3vw;
			width: 15vw;
			height: 4vw;
		}

		.hamburger {
			display: block;
		}

		.navigation-menu ul {
			flex-direction: column;
			position: absolute;
			top: 70px;
			left: 0;
			width: 100%;
			height: auto;
			background: #0A0B0D 0% 0% no-repeat padding-box;		
			z-index: 2;
			display: none;
		}

		.navigation-menu li {
			text-align: center;
			margin: 0;
		}

		.navigation-menu li a {
			color: white;
			width: 100%;
			padding: 1.5rem 0;
		}

		.navigation-menu li:hover {
			background-color: #1f232a;
		}

		.signinbtn {
			width: fit-content;
			height: auto;
			padding: 5px 15px;
			cursor: pointer;
			border: none;
			outline: none;
			background: #44b2dd 0% 0% no-repeat padding-box;
			border-radius: 4px;
			font: normal normal normal 1vw/1vw Nexa-bold;
			color: #ffffff;
		}

		.startMobile{
			display: block;
		}

		.signMobile{
			font-family: Nexa-bold;
			display: block;
		}

		.navigation-menu.expanded ul {
			display: block;
			margin-top: -6px;
			z-index: 101;
		}
	}

	@media screen and ${breakpoints.device.mobileL} {
		font-size: 4vw;

		.signinbtn {
			font-size: 4vw;
			width: 45vw;
			height: 10vw;
		}

		.hamburger {
			svg {
				height: 2.1em;
				width: 2.1em;
			}
		}
	}
`;

const Navigation = ({ setIsSubModalOpen, setAliveSubModalOpen, setSmartSubModalOpen }) => {
	const [isNavExpanded, setIsNavExpanded] = useState(false);
	//const isReplicated = window.replicated;
	const isReplicated = true;

	window.onload = () => setIsNavExpanded(false);
	
		var url_string = window.location.href;
		var url = new URL(url_string);
		var p = url.searchParams.get("enrolling");
		console.log(p);
		if(p === "true"){
			setIsSubModalOpen(true);
		}

		if(p == 'aliveproducts'){
			setAliveSubModalOpen(true);
		}

		if(p == 'smartfinance'){
			setSmartSubModalOpen(true)
		}
	
	

	return (
		<StyledNav>
			<div className="logo">
							<Link to="/">
								<img src={logo} alt="logo" />
							</Link>
						</div>
			<button
				className="hamburger"
				onClick={() => {
					setIsNavExpanded(!isNavExpanded);
				}}>
				<IconContext.Provider
					value={{
						color: "white",
						height: "2em",
					}}>
					<HiMenu />
				</IconContext.Provider>
			</button>
			<div
				className={
					isNavExpanded
						? "navigation-menu expanded"
						: "navigation-menu"
				}>
				<ul>
					<li
						onClick={() => {
							setIsNavExpanded(
								!isNavExpanded
							);
						}}>
						<Link to="/">Home</Link>
					</li>
					<li
						onClick={() => {
							setIsNavExpanded(
								!isNavExpanded
							);
						}}>
						<Link to="/products">
							Products
						</Link>
					</li>
					
					<li
						onClick={() => {
							setIsNavExpanded(
								!isNavExpanded
							);
						}}>
						<Link to="/memberbenefits">
							Member Benefits
						</Link>
					</li>
					<li
						onClick={() => {
							setIsNavExpanded(
								!isNavExpanded
							);
						}}>
						<Link to="/events">Events</Link>
					</li>
					<li
						onClick={() => {
							setIsNavExpanded(
								!isNavExpanded
							);
						}}>
						<Link to="/successstories">
							Success Stories
						</Link>
					</li>
					<li>
						<DropDown
							closeNav={
								setIsNavExpanded
							}
							checkNav={isNavExpanded}
						/>
					</li>

					{isReplicated ? 
							<li className="startMobile">
								<a href="#home">
									<span
										onClick={() => {
											console.log(
												"KILROY WAS HERE?",
												setIsSubModalOpen
											);
											setIsSubModalOpen(
												true
											);
										}}
										className="signinbtn">
										Get Started
									</span>
								</a> 
							</li> : '' }
						<li className="signMobile">
							
							<a href="https://shield.igenius.biz/login.html">							
								
									Sign In
								
							</a>
						</li>	
					
					
				</ul>
			</div>
		</StyledNav>
	);
};

export default Navigation;
